var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWcag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 512,
    viewBox: "0 0 640 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7998 5.09781C28.3998 -3.10219 13.2998 -1.20219 5.09976 9.19781C-3.10024 19.5978 -1.20024 34.6978 9.19976 42.8978L601.2 506.898C611.6 515.098 626.7 513.198 634.9 502.798C643.1 492.398 641.2 477.298 630.8 469.098L525.6 386.698C565.2 346.098 592 300.598 605.5 268.298C608.8 260.398 608.8 251.598 605.5 243.698C590.6 207.998 559.3 155.998 512.5 112.598C465.5 68.7978 400.8 31.9978 320 31.9978C251.8 31.9978 195 58.2978 150.7 92.7978L38.7998 5.09781ZM223 149.498C271.6 105.198 346 98.6978 402.3 137.798C463.1 180.198 481.2 260.998 446.5 324.698L408 294.498C416.4 275.198 418.6 253.098 412.8 231.198C401.7 189.698 365 161.798 324.2 160.098C318.4 159.898 315 166.198 316.8 171.798C318.9 178.198 320.1 184.998 320.1 192.098C320.1 202.298 317.7 211.898 313.5 220.398L223 149.498ZM446.1 447.498L83.0998 161.498C72.0998 175.898 62.5998 190.198 54.6998 203.698L393.7 469.398C412.4 463.898 429.9 456.398 446.3 447.598L446.1 447.498ZM34.4998 268.298C49.3998 303.998 80.6998 355.998 127.5 399.398C174.5 443.198 239.2 479.998 320 479.998C323.1 479.998 326.1 479.898 329.2 479.798L33.0998 247.798C31.2998 254.598 31.7998 261.798 34.4998 268.298Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcag);
export default __webpack_public_path__ + "static/media/wcag.fb2067e999c54571eb0e0121149e8382.svg";
export { ForwardRef as ReactComponent };